import { MutationCache, QueryClient, QueryKey } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

declare module '@tanstack/react-query' {
  export interface Register {
    queryMeta: {
      errorMessage?: string;
    };
    mutationMeta: {
      invalidatesQuery?: QueryKey | QueryKey[];
      invalidatesQueries?: QueryKey[];
      successMessage?: string;
      errorMessage?: string;
    };
  }
}

// 401s are handled by the axios response interceptor (token refresh + redirect),
// so no queryCache.onError handling is needed here.
export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      if (mutation.meta?.successMessage) {
        enqueueSnackbar(mutation.meta.successMessage, {
          variant: 'success',
          autoHideDuration: 1250,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
        });
      }
    },
    onError: (_data, _variables, _context, mutation) => {
      if (mutation.meta?.errorMessage) {
        enqueueSnackbar(mutation.meta.errorMessage, {
          variant: 'error',
          autoHideDuration: 1250,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
        });
      }
    },
    onSettled: async (_data, _error, _variables, _context, mutation) => {
      if (mutation.meta?.invalidatesQuery) {
        queryClient.invalidateQueries({
          queryKey: mutation.meta?.invalidatesQuery,
        });
      }

      if (mutation.meta?.invalidatesQueries) {
        mutation.meta?.invalidatesQueries.forEach(async queryKey => {
          await queryClient.invalidateQueries({ queryKey });
        });
      }
    },
  }),
});
